/**
 * Boot-time appearance preferences (density + Phase T theme product).
 */
import { initDensityPreference } from './densityPreferenceService';
import { initThemePreference } from './themePreferenceService';

export function initAppearancePreferences() {
  initThemePreference();
  initDensityPreference();
}
